import React from 'react';
import '../InsuranceCard/InsuranceCard.css';


const InsuranceCard = ({ icon, label, onClick }) => {
  return (
   
      <div className="text-center">
        <img src={icon} alt={label} onClick={onClick} className="insurance-card-img" />
        <div className="card-body p-2">
          <p className="insurance-card-text fw-bold mb-0">{label}</p>
        </div>
      </div>
   
  );
};


export default InsuranceCard;
